import { useEffect, useState } from "react";
import { Image } from "antd";
import GOVCO from "../../../assets/landing/Logo.png";
import Escudo from "../../../assets/landing/Escudo.png";
import EscudoAlcaldiaBlanco from "../../../assets/landing/logo3.png";
import "./header.style.scss";
import { useNavigate } from "react-router";
import Buscador_icon from "../../../assets/Buscador.svg";
import { HeaderMobile } from "./headerMobile";

export const Header = () => {
   const navigate = useNavigate();
   const goLogin = (): void => {
      navigate("/login");
   };
   const [isLogged, setisLogged] = useState<any>(false)

   useEffect(() => {
      const user = localStorage.getItem('user')
      if (user) {
         setisLogged(true)
      }
   }, [localStorage.token])

   return (
      <div className="sticky">
        <HeaderMobile/>
         <div className="container__header">
            <div className="container-fluid2">
               <div className="row font-size-10px">
                  <div className="col-4 col-md-4 justify-content-flex-start d-flex align-items-center align-content-center">
                     <Image src={GOVCO} className="img-fluid align-items-center align-content-center" preview={false} style={{ maxHeight: "30px" }} />
                  </div>
                  <div className="col justify-content-flex-end">
                     <div className="row justify-content-end" style={{ alignItems: "center" }}>
                        {isLogged &&
                           <>
                              <div className="col justify-content-flex-end landing-iniciar-sesion font-family-Montserrat-Regular"
                                    style={{ color: "#FFFFFF" }}
                                    onClick={() => navigate("/usuario")}
                                    role="button"
                                    onKeyDown={(e) => {
                                       if (e.key === "Enter" || e.key === " ") {
                                         e.preventDefault();
                                         navigate("/usuario");
                                       }
                                    }}
                                    tabIndex={0}
                              >
                                 Inicio
                              </div>
                              <div
                                 onClick={() => {
                                    localStorage.removeItem("token");
                                    localStorage.removeItem("user");
                                    localStorage.clear();
                                    window.location.replace('https://www.medellin.gov.co/es/secretaria-cultura-ciudadana/estimulos-cultura/');
                                 }}
                                 role="button"
                                 onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                      e.preventDefault();
                                      localStorage.removeItem("token");
                                      localStorage.removeItem("user");
                                      localStorage.clear();
                                      window.location.replace('https://www.medellin.gov.co/es/secretaria-cultura-ciudadana/estimulos-cultura/');
                                    }
                                  }}
                                  tabIndex={1}
                                 className="col justify-content-flex-end font-family-Montserrat-Regular text-nowrap"
                                 style={{ color: "#FFFFFF", cursor: "pointer" }}
                              >
                                 Cerrar sesión
                              </div>
                              <div className="col" style={{ alignItems: "center" }}>
                                 <Image src={EscudoAlcaldiaBlanco} className="img-fluid" style={{ maxHeight: "30px", maxWidth: "30px" }} preview={false} />
                              </div>
                           </>
                        }
                        {!isLogged &&
                           <>
                              <div className="col landing-registrarse font-family-Montserrat-Regular" style={{ color: "#FFFFFF" }}
                                    onClick={() => { window.location.href = "https://www.medellin.gov.co/estimuloscultura/#convocatorias"; }}
                                    role="button"
                                    tabIndex={2}
                                    onKeyDown={(e) => {
                                       if (e.key === "Enter" || e.key === " ") {
                                          e.preventDefault();
                                          window.location.href = "https://www.medellin.gov.co/estimuloscultura/#convocatorias";
                                       }
                                    }}
                              >
                                 Convocatorias
                              </div>
                              <div
                                 onClick={goLogin}
                                 className="col justify-content-flex-end text-nowrap landing-iniciar-sesion font-family-Montserrat-Regular"
                                 style={{ color: "#FFFFFF" }}
                                 role="button"
                                 tabIndex={3}
                                 onKeyDown={(e) => {
                                    if (e.key === "Enter" || e.key === " ") {
                                       e.preventDefault();
                                       goLogin
                                    }
                                 }}
                              >
                                 Iniciar sesión
                              </div>
                              <div className="col landing-registrarse font-family-Montserrat-Regular"
                                    style={{ color: "#FFFFFF" }}
                                    onClick={() => { window.location.href = "https://www.medellin.gov.co/registrate"; }}
                                    role="button"
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                       if (e.key === "Enter" || e.key === " ") {
                                          e.preventDefault();
                                          window.location.href = "https://www.medellin.gov.co/registrate";
                                       }
                                    }}
                                 >
                                 Regístrate
                              </div>
                              <div className="col" style={{ alignItems: "center" }}>
                                 <Image src={EscudoAlcaldiaBlanco} className="img-fluid" style={{ maxHeight: "30px", maxWidth: "30px" }} preview={false} />
                              </div>
                           </>
                        }
                     </div>
                  </div>
               </div>
            </div>
         </div>
         {/*
         <div className="container__shield__section sticky">
            <div className="container-fluid2">
               <div className="d-flex flex-row align-content-center align-items-center header_alcaldia">
                  <div className="d-flex pe-3">
                     <a href="https://www.medellin.gov.co/es/secretaria-cultura-ciudadana/">
                        <Image style={{ cursor: "pointer", maxWidth: "175px" }} src={Escudo} className="img-fluid" preview={false} /></a>
                  </div>
                  <div className="menu_alcaldia_ flex-row justify-content-end">
                     <ul>
                        <div className="menu-menu-principal-container">
                           <ul id="menu-menu-principal" className="menu2">
                              <li id="menu-item-40047" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-40047"><a href="https://www.medellin.gov.co/es/participa/"><span id="HParticipacion" title="Participa">Participa</span></a></li>
                              <li id="menu-item-40043" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-40043"><a href="https://www.medellin.gov.co/es/transparencia/"><span id="HTransparencia" title="Transparencia">Transparencia</span></a></li>
                              <li id="menu-item-23642" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-23642"><a href="https://www.medellin.gov.co/es/secretaria-de-gestion-humana/servicio-a-la-ciudadania/"><span id="HServiCiuda" title="Servicios a la ciudadanía">Servicios a la Ciudadanía</span></a></li>
                              <li id="menu-item-7055" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-7055"><a href="https://www.medellin.gov.co/es/sala-de-prensa/"><span id="HSalaPrensa" title="Sala de prensa">Sala de prensa</span></a></li>
                              <li id="menu-item-44397" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-44397"><a href="https://www.medellin.gov.co/es/pqrsd/"><span id="HPQRSD" title="PQRSD">PQRSD</span></a></li>
                              <li id="menu-item-75728" className="menu-item menu-item-type-custom menu-item-object-custom menu-item-75728"><a href="https://www.medellin.gov.co/es/pago-de-impuestos-alcaldia-de-medellin/">Impuestos</a></li>
                              <li id="menu-item-15041" className="menu-item menu-item-type-post_type menu-item-object-page menu-item-15041"><a href="https://www.medellin.gov.co/es/tramites-y-servicios/"><span id="HTramitesS" className="orange_" title="Trámites y Servicios">Trámites y Servicios</span></a></li>
                              <li className="busca_menu_icon" title=" Busca, explora y encuentra todo lo que la Alcaldía tiene para ti">
                                 <a id="HBuscador" href="https://www.medellin.gov.co/es/?s=" data-toggle="modal" data-target="#exampleModal" title=" Busca, explora y encuentra todo lo que la Alcaldía tiene para ti">
                                    <img src={Buscador_icon} title="" style={{ width: '30px' }} />
                                 </a>
                              </li>
                           </ul>
                        </div>
                     </ul>
                  </div>
               </div>
            </div>
         </div>
         */}
      </div>
   );
};